import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { MapPin, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { getDistricts } from "@/lib/api";

export const Districts = () => {
  const { data: districts = [] } = useQuery({ queryKey: ["districts"], queryFn: getDistricts });

  return (
    <section id="ilceler" className="section-pad bg-[#0E0F10] scroll-mt-24">
      <div className="container-lux">
        <Reveal>
          <div className="text-center max-w-3xl mx-auto">
            <span className="eyebrow justify-center">Ankara'nın Tüm İlçeleri</span>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#F7F2E8] mt-3">
              İlçenize özel düğün fotoğrafçısı
            </h2>
            <p className="text-[#9A9387] mt-4">
              Ankara'nın 25 ilçesinin her biri için en iyi çekim noktalarını, mevsim ve ışık tavsiyelerini
              hazırladık. İlçenizi seçin, size özel rehberi ve rezervasyon seçeneklerini görün.
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 mt-12">
          {districts.map((d, i) => (
            <Reveal key={d.slug} delay={(i % 10) * 0.03}>
              <Link
                to={`/ankara/${d.page_slug}`}
                data-testid="district-card-link"
                className="group flex items-center justify-between gap-2 rounded-xl border border-white/10 bg-[#141517] px-4 py-3.5 hover:border-[rgba(200,162,74,0.5)] hover:bg-[#1A1B1E] transition-colors"
              >
                <span className="flex items-center gap-2 min-w-0">
                  <MapPin className="w-4 h-4 text-[#C8A24A] shrink-0" />
                  <span className="text-sm text-[#EDE7DA] truncate">{d.name}</span>
                </span>
                <ArrowUpRight className="w-4 h-4 text-[#7C766B] group-hover:text-[#C8A24A] transition-colors shrink-0" />
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Districts;
